/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_bookmark__save_favorite_route = /** @type {(inputs: {}) => string} */ () => {
	return `Speichern Sie Ihre bevorzugten Routen`
};

const en_bookmark__save_favorite_route = /** @type {(inputs: {}) => string} */ () => {
	return `Save your favourite routes`
};

const es_bookmark__save_favorite_route = /** @type {(inputs: {}) => string} */ () => {
	return `Guarda tus itinerarios favoritos`
};

const fr_bookmark__save_favorite_route = /** @type {(inputs: {}) => string} */ () => {
	return `Sauvegardez vos itinéraires favoris`
};

const it_bookmark__save_favorite_route = /** @type {(inputs: {}) => string} */ () => {
	return `Salva i tuoi itinerari preferiti`
};

const nl_bookmark__save_favorite_route = /** @type {(inputs: {}) => string} */ () => {
	return `Favoriete routes opslaan`
};

const pt_bookmark__save_favorite_route = /** @type {(inputs: {}) => string} */ () => {
	return `Guarde os seus itinerários favoritos`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__save_favorite_route = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bookmark__save_favorite_route(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bookmark__save_favorite_route", locale)
	if (locale === "de") return de_bookmark__save_favorite_route(inputs)
	if (locale === "en") return en_bookmark__save_favorite_route(inputs)
	if (locale === "es") return es_bookmark__save_favorite_route(inputs)
	if (locale === "fr") return fr_bookmark__save_favorite_route(inputs)
	if (locale === "it") return it_bookmark__save_favorite_route(inputs)
	if (locale === "nl") return nl_bookmark__save_favorite_route(inputs)
	return pt_bookmark__save_favorite_route(inputs)
};